module.exports = __webpack_public_path__ + "static/media/undraw_online_chat_d7ek.ba5be112.svg";